<lib-date-filter

#handlerRouter="routerListenChange"
routerListenChange
[max_date]="option_from.max_date"
[min_date]="option_from.min_date"
(changeData)="handlerRouter.performNavigation($event)"
[routerParamsData]="{'intercept_name': option_from.intercept_name, 'delay_time': option_from.delay_time}"
*ngIf="hide!==true" [id]="option_from.id" [placeholder]="option_from.placeholder" [dateFormControl]="option_from.date_subject"
  [date_subject]="option_from.date_subject" [format]="option_from.date_format"></lib-date-filter>
<lib-date-filter
#handlerRouter="routerListenChange"
routerListenChange
[max_date]="option_to.max_date"
[min_date]="option_to.min_date"
(changeData)="handlerRouter.performNavigation($event)"
[routerParamsData]="{'intercept_name': option_to.intercept_name, 'delay_time': option_to.delay_time}"
*ngIf="hide!==true" [id]="option_to.id" [placeholder]="option_to.placeholder" [dateFormControl]="option_to.date_subject"
  [date_subject]="option_to.date_subject" [format]="option_to.date_format"></lib-date-filter>
